export default __webpack_public_path__ + "static/media/three-whales-bg.540501c3.png";